<script>
    import { _ } from "../services/i18n";
    import HeaderHome from "../components/HeaderHome.svelte";
    import HeaderCurrentClientInfo from "../components/HeaderCurrentClientInfo.svelte";
    import { settingsHeaderLinksStore } from "../services/header";
    import { userStore } from "../services/session";
    import Form from "../components/Form.svelte";

    import { getColorSchemes, getComputedVariable, storeColorScheme, applyColorScheme } from "../services/colorScheme";
    import { onMount } from "svelte";

    const linksHeader = $settingsHeaderLinksStore;

    let colorSchemeData = [];
    let defaultColor1 = getComputedVariable("--theme-color-1");
    let defaultColor2 = getComputedVariable("--theme-color-2");
    let defaultColor3 = getComputedVariable("--theme-color-3");
    let defaultColor4 = getComputedVariable("--theme-color-4");

    console.log("defaultColor1", defaultColor1);
    let prevAppTheme = null;
    let prevReportTheme = null;

    var appColors = {
        themeColor1: defaultColor1,
        themeColor2: defaultColor2,
        themeColor3: defaultColor3,
        themeColor4: defaultColor4
    }

    var reportColors = {
        themeColor1: defaultColor1,
        themeColor2: defaultColor2,
        themeColor3: defaultColor3,
        themeColor4: defaultColor4
    }

    const getColor = (definition, index, fallback) => {
        const color = definition[`theme-color-${index}`];
        return color !== null && color !== undefined && color !== "" ? color : fallback;
    }

    onMount(async () => {
        colorSchemeData = await getColorSchemes();

        if (colorSchemeData) {
            colorSchemeData.forEach(c => {
                if (c.type === "application") {
                    appColors = {
                        themeColor1: getColor(c.definition, 1, defaultColor1),
                        themeColor2: getColor(c.definition, 2, defaultColor2),
                        themeColor3: getColor(c.definition, 3, defaultColor3),
                        themeColor4: getColor(c.definition, 4, defaultColor4)
                    }
                    prevAppTheme = structuredClone(appColors);
                }
                else if (c.type === "reports") {
                    reportColors = {
                        themeColor1: getColor(c.definition, 1, defaultColor1),
                        themeColor2: getColor(c.definition, 2, defaultColor2),
                        themeColor3: getColor(c.definition, 3, defaultColor3),
                        themeColor4: getColor(c.definition, 4, defaultColor4)
                    }
                    prevReportTheme = structuredClone(reportColors);
                }
            
            });
        }

    });

    const submitColors = async (evt, type) => {
        evt.preventDefault();
        if (type === "application") {
            appColors = {
                themeColor1: evt.detail["theme-color-1"],
                themeColor2: evt.detail["theme-color-2"],
                themeColor3: evt.detail["theme-color-3"],
                themeColor4: evt.detail["theme-color-4"]
            }
            appColorsChanged = false;
        }
        else {
            reportColors = {
                themeColor1: evt.detail["theme-color-1"],
                themeColor2: evt.detail["theme-color-2"],
                themeColor3: evt.detail["theme-color-3"],
                themeColor4: evt.detail["theme-color-4"]
            }
            reportColorsChanged = false;
        }
        const definition = { 
            "theme-color-1": evt.detail["theme-color-1"], 
            "theme-color-2": evt.detail["theme-color-2"], 
            "theme-color-3": evt.detail["theme-color-3"], 
            "theme-color-4": evt.detail["theme-color-4"]
        };
        if (await storeColorScheme(type, definition) && type === "application") {
            applyColorScheme(null, definition);
        }
    }

    const cancelColors = (type) => {
        if (type === "application") {
            appColors = structuredClone(prevAppTheme);
            appColorsChanged = false;
        }
        else if (type === "reports") {
            reportColors = structuredClone(prevReportTheme);
            reportColorsChanged = false;
        }
    }

    const onAppColorsChanged = () => {
        appColorsChanged = true;
    }

    const onReportColorsChanged = () => {
        reportColorsChanged = true;
    }

    const defaultColors = [
        "#36a9e1",
        "#5c8fcb",
        "#27589c",
        "#1b3258"
    ];

    const restoreAppColors = () => {
        appColors = {
            themeColor1: defaultColors[0],
            themeColor2: defaultColors[1],
            themeColor3: defaultColors[2],
            themeColor4: defaultColors[3]
        }
        appColorsChanged = true;
    }

    const restoreReportColors = () => {
        reportColors = {
            themeColor1: defaultColors[0],
            themeColor2: defaultColors[1],
            themeColor3: defaultColors[2],
            themeColor4: defaultColors[3]
        }
        reportColorsChanged = true;
    }

    let appColorsChanged = false;
    let reportColorsChanged = false;

</script>

<HeaderHome links={linksHeader} />
<HeaderCurrentClientInfo customText={$_("header_colorSchemes")} />


<header>
    <h3>{$_("colorSchemes_sectionTitle")}</h3>
</header>

<main>
    {#if $userStore.getAcl('appColors')}
        <section>
            <h4>{$_("colorSchemes_applicationTitle")}</h4>
            <Form fields={[
                { type: "color", name: "theme-color-1", id: "theme-color-1", label: "Color 1", required: true, value: appColors.themeColor1, onChanged: onAppColorsChanged },
                { type: "color", name: "theme-color-2", id: "theme-color-2", label: "Color 2", required: true, value: appColors.themeColor2, onChanged: onAppColorsChanged },
                { type: "color", name: "theme-color-3", id: "theme-color-3", label: "Color 3", required: true, value: appColors.themeColor3, onChanged: onAppColorsChanged },
                { type: "color", name: "theme-color-4", id: "theme-color-4", label: "Color 4", required: true, value: appColors.themeColor4, onChanged: onAppColorsChanged }
            ]} on:submit={evt => submitColors(evt, "application")} on:cancel={evt => cancelColors("application")} buttonLabel="ui_form_save">
                <button type="button" slot="extra-fields" on:click={restoreAppColors}>Restaurar</button>
            </Form>
        </section>
    {/if}
    {#if $userStore.getAcl('reportColors')}
        <section>
            <h4>{$_("colorSchemes_reportsTitle")}</h4>
            <Form fields={[
                { type: "color", name: "theme-color-1", id: "theme-color-1", label: "Color 1", required: true, value: reportColors.themeColor1, onChanged: onReportColorsChanged },
                { type: "color", name: "theme-color-2", id: "theme-color-2", label: "Color 2", required: true, value: reportColors.themeColor2, onChanged: onReportColorsChanged },
                { type: "color", name: "theme-color-3", id: "theme-color-3", label: "Color 3", required: true, value: reportColors.themeColor3, onChanged: onReportColorsChanged },
                { type: "color", name: "theme-color-4", id: "theme-color-4", label: "Color 4", required: true, value: reportColors.themeColor4, onChanged: onReportColorsChanged }
            ]} on:submit={evt => submitColors(evt, "reports")} on:cancel={evt => cancelColors("reports")} buttonLabel="ui_form_save">
            <button type="button" slot="extra-fields" on:click={restoreReportColors}>Restaurar</button>
            </Form>
        </section>
    {/if}
</main
>
<footer>
    {#if appColorsChanged || reportColorsChanged}
        <p class="card warning-message">{$_("colorSchemes_unsavedChanges")}</p>
    {/if}
</footer>

<style>
    header {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    main {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    footer {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    .warning-message {
        background: var(--bkg-color-warning);
        text-align: center;
        padding: 30px;
    }
</style>